<template>

    <form ref="estagioduracaominima-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">


            <div class="form-group col-md-12">
                <label for="numeroMinimo">Quantidade Mínima de Alunos</label>
                <input type="number" class="form-control" min="0" name="numeroMinimo" placeholder="Quantidade Mínima de Alunos" v-model="model.numeroMinimo" required />
            </div>

            <div class="form-group col-md-12">
                <label for="numeroMaximo">Quantidade Máxima de Alunos</label>
                <input type="number" class="form-control" min="0" name="numeroMaximo" placeholder="Quantidade Máxima de Alunos" v-model="model.numeroMaximo" required />
            </div>

            <div class="form-group col-md-12">
                <label for="duracao">Duração</label>
                <input type="number" class="form-control" min="0" name="duracao" placeholder="Duração" v-model="model.duracao" required />
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "estagioduracaominima-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "estagioduracaominima-form-edit",
            
            resources: {
                edit: 'estagioduracaominima',
            },

        }),
		
        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false)return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ estagioDuracaoMinimaId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>